import { render, staticRenderFns } from "./multipleSelect.vue?vue&type=template&id=6fc23490"
import script from "./multipleSelect.vue?vue&type=script&lang=js"
export * from "./multipleSelect.vue?vue&type=script&lang=js"
import style0 from "./multipleSelect.vue?vue&type=style&index=0&id=6fc23490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports